import { useMemo } from 'react'
import useAssets from '../../../hooks/useAssets'
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite'
import { Exposer, ExposerContainer } from '../../../../../CommonComponents/timeline/Timeline'

const SunExposers = () => {
    const { orbitalInsights } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const selectedOrbitalInsights = useMemo(() => (selectedSatellite && orbitalInsights?.data) ? orbitalInsights?.data[selectedSatellite] : null, [orbitalInsights.data, selectedSatellite])
    const Exposers = useMemo(() => selectedOrbitalInsights?.allOrbits?.sunExposures || [], [selectedOrbitalInsights?.allOrbits.sunExposures])

    return (
        <ExposerContainer>
            {Exposers.map((exposer, index) => {
                return (
                    <Exposer
                        key={`exposer-${index}`}
                        exposerStartTime={exposer.startTime}
                        exposerEndTime={exposer.endTime}
                        exposerDuration={exposer.duration}
                        exposerType={exposer.exposureType}
                    />
                )
            })}
        </ExposerContainer>
    )
}

export default SunExposers